export default __webpack_public_path__ + "static/media/icon-28.c4ac7a9d.png";